"use strict"

export function initInScope ($scope) {
    let $percentageItem = $scope.find('.js-percentage-indicator__item');
    let percentage = $percentageItem.attr('data-percentage');
    $percentageItem.css("background", "conic-gradient(var(--color-primary)" + percentage + "%, var(--color-grey)" + percentage +"% )");
}